/**
 * Presentation metadata for the gate's five tabs.
 *
 * The whole journey is on screen, and every tab carries a count. Outward covers Stock Transfer
 * trucks: pending until the guard raises a Gate Pass Out, done after.
 */
import {
  GATE_TABS,
  GATE_TABS_IMPLEMENTED,
  type GateTab,
} from "@nexseed/shared";
import type { TabTone } from "@/components/ui/tabs";

export { GATE_TABS, GATE_TABS_IMPLEMENTED };
export type { GateTab };

export interface GateTabMeta {
  label: string;
  tone: TabTone;
  /** False = renders, but carries no count and lists nothing. */
  implemented: boolean;
  /** Shown in the empty panel of a tab that is not built yet. */
  comingSoon?: string;
}

export const GATE_TAB_META: Record<GateTab, GateTabMeta> = {
  all: { label: "All", tone: "neutral", implemented: true },
  inward_pending: {
    label: "Inward Pending",
    tone: "progress",
    implemented: true,
  },
  inward_done: { label: "Inward Done", tone: "success", implemented: true },
  outward_pending: {
    label: "Outward Pending",
    tone: "warning",
    implemented: true,
  },
  outward_done: { label: "Outward Done", tone: "neutral", implemented: true },
};

export const isGateTab = (v: string): v is GateTab =>
  (GATE_TABS as readonly string[]).includes(v);
